module.exports = __webpack_public_path__ + "img/4.48b50527.jpg";